import { useMemo } from 'react';
import { DateTime, Interval } from "luxon";
import { SLOT_1_END, SLOT_1_START, SLOT_2_END, SLOT_2_START } from "../constants/serviceSlots";

interface ServiceSlotsProps {
  day: DateTime,
  scheduledIntervals: Interval[];
}
function useServiceSlots(props:ServiceSlotsProps) {
  const {day, scheduledIntervals = []} = props;

  const slot1 = useMemo(() => {
    return Interval.fromDateTimes(
      day.setZone('local').set(SLOT_1_START),
      day.setZone('local').set(SLOT_1_END)
    );
  }, [day]);

  const slot2 = useMemo(() => {
    return Interval.fromDateTimes(
      day.setZone('local').set(SLOT_2_START),
      day.setZone('local').set(SLOT_2_END)
    );
  }, [day]);

  const slotsAvailability: boolean[] = useMemo(() => {
    return [
      scheduledIntervals.some(int => !!int.intersection(slot1)),
      scheduledIntervals.some(int => !!int.intersection(slot2)),
    ];
  }, [slot1, slot2, scheduledIntervals]);

  const allEmpty = slotsAvailability.every(i => !i);
  const someBusy = slotsAvailability.some(i => !!i);
  const allBusy = slotsAvailability.every(i => !!i);

  return {
    slot1,
    slot2,
    slotsAvailability,
    allEmpty,
    someBusy,
    allBusy,
  }
}

export default useServiceSlots;
